<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div div class="col-md-12 footer-copyright text-center" style="text-transform: lowercase;
    ">
      <!-- <p class="mb-0"> Collaborate 2022 All Rights Reserved, Developed & Powered by wecancity.com © </p> -->
    <p class="mb-0">  © ekram dashboard {{year}} All Rights Reserved Developed & Powered by <a style="cursor: pointer !important;" href="http://www.wecancity.com" target="_blank">
      wecancity.com
    </a> </p>
   
    </div>
  </div>
</div>

 